export default __webpack_public_path__ + "static/media/Frame2.b5989249.png";